var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadSimple10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UploadSimple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.75 5.625V8.125C8.75 8.20788 8.71708 8.28737 8.65847 8.34597C8.59987 8.40458 8.52038 8.4375 8.4375 8.4375H1.5625C1.47962 8.4375 1.40013 8.40458 1.34153 8.34597C1.28292 8.28737 1.25 8.20788 1.25 8.125V5.625C1.25 5.54212 1.28292 5.46263 1.34153 5.40403C1.40013 5.34542 1.47962 5.3125 1.5625 5.3125C1.64538 5.3125 1.72487 5.34542 1.78347 5.40403C1.84208 5.46263 1.875 5.54212 1.875 5.625V7.8125H8.125V5.625C8.125 5.54212 8.15792 5.46263 8.21653 5.40403C8.27513 5.34542 8.35462 5.3125 8.4375 5.3125C8.52038 5.3125 8.59987 5.34542 8.65847 5.40403C8.71708 5.46263 8.75 5.54212 8.75 5.625ZM3.65859 3.03359L4.6875 2.0043V5.625C4.6875 5.70788 4.72042 5.78737 4.77903 5.84597C4.83763 5.90458 4.91712 5.9375 5 5.9375C5.08288 5.9375 5.16237 5.90458 5.22097 5.84597C5.27958 5.78737 5.3125 5.70788 5.3125 5.625V2.0043L6.34141 3.03359C6.40004 3.09223 6.47957 3.12517 6.5625 3.12517C6.64543 3.12517 6.72496 3.09223 6.78359 3.03359C6.84223 2.97496 6.87517 2.89543 6.87517 2.8125C6.87517 2.72957 6.84223 2.65004 6.78359 2.59141L5.22109 1.02891C5.19207 0.999851 5.15761 0.976801 5.11967 0.961075C5.08173 0.945349 5.04107 0.937254 5 0.937254C4.95893 0.937254 4.91827 0.945349 4.88033 0.961075C4.84239 0.976801 4.80793 0.999851 4.77891 1.02891L3.21641 2.59141C3.15777 2.65004 3.12483 2.72957 3.12483 2.8125C3.12483 2.89543 3.15777 2.97496 3.21641 3.03359C3.27504 3.09223 3.35457 3.12517 3.4375 3.12517C3.52043 3.12517 3.59996 3.09223 3.65859 3.03359Z",
    fill: "#000A8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSimple10);
export default __webpack_public_path__ + "static/media/UploadSimple10.25495f28.svg";
export { ForwardRef as ReactComponent };